import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=60188e02&scoped=true"
import script from "./PaperList.vue?vue&type=script&lang=js"
export * from "./PaperList.vue?vue&type=script&lang=js"
import style0 from "./PaperList.vue?vue&type=style&index=0&id=60188e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60188e02",
  null
  
)

export default component.exports